import AppHeader from "../../layout/AppHeader";
import ReverseLogistics from '../../xpost/views/services/reverse.logistics/ReverseLogistics.vue';
import ReverseLogisticsAdd from '../../xpost/views/services/reverse.logistics/ReverseLogisticsAdd.vue';

const ReverseLogisticsRoutes = [
  {
    path: "/servicos/reversa",
    name: "reverse.logistics",
    components: {
      header: AppHeader,
      default: ReverseLogistics
    }
  },
  {
    path: "/servicos/reversa/adicionar",
    name: "reverse.logistics.add",
    components: {
      header: AppHeader,
      default: ReverseLogisticsAdd
    },
  },
  {
    path: "/servicos/reversa/adicionar/:tag",
    name: "reverse.logistics.add.tag",
    components: {
      header: AppHeader,
      default: ReverseLogisticsAdd
    },
  },
  {
    path: "/servicos/reversa/:id",
    name: "reverse.logistics.object",
    components: {
      header: AppHeader,
      default: ReverseLogistics
    }
  },
]

export default ReverseLogisticsRoutes;